import React from "react";
import { ITotoProps } from "@/types/GlobalTypes";
import { isIPad, isIPadOS } from "@/modules/iOSDetection";

import "./index.scss";
import { TotoTable } from "@/modules/commonMobile";

export default class MaximizeTotoGame extends React.PureComponent<ITotoProps> {
	render() {
		const activeGame = this.props.data;

		// Don't render if there are more than 1 active game
		if (this.props.activeGameCount > 1 || !activeGame.active)
			return null;

		const { userdata, lang } = this.props;
		const { pcode } = activeGame;

		return (
			<div className={"sl-game v5" +
				(activeGame.maximised ? " sl-single-game-v2" : " sl-multi-table") +
				(activeGame.transparentChips ? " transparent-chips" : "") +
				(isIPad() || isIPadOS() ? " ipad" : "")}>

				<div className="container-gamev5">
					<TotoTable
						pcode={pcode}
						data={activeGame}
						langdata={lang}
						maximised={activeGame.maximised}
						userdata={userdata} />
				</div>

			</div>
		)
	}
}